const SET_SORT = 'SET_SORT'
const SET_REFRESHING_DATA = 'SET_REFRESHING_DATA'
const SET_LOCALE = 'SET_LOCALE'

const state = () => {
  return {
    locale: 'fr',
    sort: {
      active: false,
    },
    refreshing: {
      data: false,
    },
  }
}

const mutations = {
  [SET_SORT]: (state, bool) => {
    state.sort.active = bool
  },
  [SET_REFRESHING_DATA]: (state, bool) => {
    state.refreshing.data = bool
  },
  [SET_LOCALE]: (state, locale) => {
    state.locale = locale
  },
}

const actions = {
  toggleSort: ({ commit, state }, bool) => {
    if (typeof bool === 'boolean') {
      commit(SET_SORT, bool)
    } else if (state.sort.active) {
      commit(SET_SORT, false)
    } else {
      commit(SET_SORT, true)
    }
  },
  toggleRefreshData: ({ commit }, bool) => {
    commit(SET_REFRESHING_DATA, bool)
  },
  updateLocale: ({ commit }, locale) => {
    commit(SET_LOCALE, locale)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
